export const SURAHS = [
  ["Al-Fatihah","الفاتحة",7,"Meccan"],["Al-Baqarah","البقرة",286,"Medinan"],
  ["Ali 'Imran","آل عمران",200,"Medinan"],["An-Nisa","النساء",176,"Medinan"],
  ["Al-Ma'idah","المائدة",120,"Medinan"],["Al-An'am","الأنعام",165,"Meccan"],
  ["Al-A'raf","الأعراف",206,"Meccan"],["Al-Anfal","الأنفال",75,"Medinan"],
  ["At-Tawbah","التوبة",129,"Medinan"],["Yunus","يونس",109,"Meccan"],
  ["Hud","هود",123,"Meccan"],["Yusuf","يوسف",111,"Meccan"],
  ["Ar-Ra'd","الرعد",43,"Medinan"],["Ibrahim","إبراهيم",52,"Meccan"],
  ["Al-Hijr","الحجر",99,"Meccan"],["An-Nahl","النحل",128,"Meccan"],
  ["Al-Isra","الإسراء",111,"Meccan"],["Al-Kahf","الكهف",110,"Meccan"],
  ["Maryam","مريم",98,"Meccan"],["Ta-Ha","طه",135,"Meccan"],
  ["Al-Anbya","الأنبياء",112,"Meccan"],["Al-Hajj","الحج",78,"Medinan"],
  ["Al-Mu'minun","المؤمنون",118,"Meccan"],["An-Nur","النور",64,"Medinan"],
  ["Al-Furqan","الفرقان",77,"Meccan"],["Ash-Shu'ara","الشعراء",227,"Meccan"],
  ["An-Naml","النمل",93,"Meccan"],["Al-Qasas","القصص",88,"Meccan"],
  ["Al-'Ankabut","العنكبوت",69,"Meccan"],["Ar-Rum","الروم",60,"Meccan"],
  ["Luqman","لقمان",34,"Meccan"],["As-Sajdah","السجدة",30,"Meccan"],
  ["Al-Ahzab","الأحزاب",73,"Medinan"],["Saba","سبأ",54,"Meccan"],
  ["Fatir","فاطر",45,"Meccan"],["Ya-Sin","يس",83,"Meccan"],
  ["As-Saffat","الصافات",182,"Meccan"],["Sad","ص",88,"Meccan"],
  ["Az-Zumar","الزمر",75,"Meccan"],["Ghafir","غافر",85,"Meccan"],
  ["Fussilat","فصلت",54,"Meccan"],["Ash-Shuraa","الشورى",53,"Meccan"],
  ["Az-Zukhruf","الزخرف",89,"Meccan"],["Ad-Dukhan","الدخان",59,"Meccan"],
  ["Al-Jathiyah","الجاثية",37,"Meccan"],["Al-Ahqaf","الأحقاف",35,"Meccan"],
  ["Muhammad","محمد",38,"Medinan"],["Al-Fath","الفتح",29,"Medinan"],
  ["Al-Hujurat","الحجرات",18,"Medinan"],["Qaf","ق",45,"Meccan"],
  ["Adh-Dhariyat","الذاريات",60,"Meccan"],["At-Tur","الطور",49,"Meccan"],
  ["An-Najm","النجم",62,"Meccan"],["Al-Qamar","القمر",55,"Meccan"],
  ["Ar-Rahman","الرحمن",78,"Medinan"],["Al-Waqi'ah","الواقعة",96,"Meccan"],
  ["Al-Hadid","الحديد",29,"Medinan"],["Al-Mujadila","المجادلة",22,"Medinan"],
  ["Al-Hashr","الحشر",24,"Medinan"],["Al-Mumtahanah","الممتحنة",13,"Medinan"],
  ["As-Saf","الصف",14,"Medinan"],["Al-Jumu'ah","الجمعة",11,"Medinan"],
  ["Al-Munafiqun","المنافقون",11,"Medinan"],["At-Taghabun","التغابن",18,"Medinan"],
  ["At-Talaq","الطلاق",12,"Medinan"],["At-Tahrim","التحريم",12,"Medinan"],
  ["Al-Mulk","الملك",30,"Meccan"],["Al-Qalam","القلم",52,"Meccan"],
  ["Al-Haqqah","الحاقة",52,"Meccan"],["Al-Ma'arij","المعارج",44,"Meccan"],
  ["Nuh","نوح",28,"Meccan"],["Al-Jinn","الجن",28,"Meccan"],
  ["Al-Muzzammil","المزمل",20,"Meccan"],["Al-Muddaththir","المدثر",56,"Meccan"],
  ["Al-Qiyamah","القيامة",40,"Meccan"],["Al-Insan","الإنسان",31,"Medinan"],
  ["Al-Mursalat","المرسلات",50,"Meccan"],["An-Naba","النبأ",40,"Meccan"],
  ["An-Nazi'at","النازعات",46,"Meccan"],["'Abasa","عبس",42,"Meccan"],
  ["At-Takwir","التكوير",29,"Meccan"],["Al-Infitar","الانفطار",19,"Meccan"],
  ["Al-Mutaffifin","المطففين",36,"Meccan"],["Al-Inshiqaq","الانشقاق",25,"Meccan"],
  ["Al-Buruj","البروج",22,"Meccan"],["At-Tariq","الطارق",17,"Meccan"],
  ["Al-A'la","الأعلى",19,"Meccan"],["Al-Ghashiyah","الغاشية",26,"Meccan"],
  ["Al-Fajr","الفجر",30,"Meccan"],["Al-Balad","البلد",20,"Meccan"],
  ["Ash-Shams","الشمس",15,"Meccan"],["Al-Layl","الليل",21,"Meccan"],
  ["Ad-Duhaa","الضحى",11,"Meccan"],["Ash-Sharh","الشرح",8,"Meccan"],
  ["At-Tin","التين",8,"Meccan"],["Al-'Alaq","العلق",19,"Meccan"],
  ["Al-Qadr","القدر",5,"Meccan"],["Al-Bayyinah","البينة",8,"Medinan"],
  ["Az-Zalzalah","الزلزلة",8,"Medinan"],["Al-'Adiyat","العاديات",11,"Meccan"],
  ["Al-Qari'ah","القارعة",11,"Meccan"],["At-Takathur","التكاثر",8,"Meccan"],
  ["Al-'Asr","العصر",3,"Meccan"],["Al-Humazah","الهمزة",9,"Meccan"],
  ["Al-Fil","الفيل",5,"Meccan"],["Quraysh","قريش",4,"Meccan"],
  ["Al-Ma'un","الماعون",7,"Meccan"],["Al-Kawthar","الكوثر",3,"Meccan"],
  ["Al-Kafirun","الكافرون",6,"Meccan"],["An-Nasr","النصر",3,"Medinan"],
  ["Al-Masad","المسد",5,"Meccan"],["Al-Ikhlas","الإخلاص",4,"Meccan"],
  ["Al-Falaq","الفلق",5,"Meccan"],["An-Nas","الناس",6,"Meccan"],
];

export const PRAYER_NAMES = [
  { key:'Fajr',    en:'Fajr',    ar:'الفجر'  },
  { key:'Sunrise', en:'Sunrise', ar:'الشروق' },
  { key:'Dhuhr',   en:'Dhuhr',   ar:'الظهر'  },
  { key:'Asr',     en:'Asr',     ar:'العصر'  },
  { key:'Maghrib', en:'Maghrib', ar:'المغرب' },
  { key:'Isha',    en:'Isha',    ar:'العشاء' },
];

export const ATHAN_SOURCES = [
  { name:'Makkah Athan',  place:'Grand Mosque',      icon:'🕋',
    urls:['https://islamiccdn.com/audio/azan/azan1.mp3','https://www.islamcan.com/audio/adhan/azan1.mp3'] },
  { name:'Madinah Athan', place:"Prophet's Mosque",  icon:'🌙',
    urls:['https://islamiccdn.com/audio/azan/azan2.mp3','https://www.islamcan.com/audio/adhan/azan2.mp3'] },
  { name:'Al-Aqsa Athan', place:'Jerusalem',          icon:'🎵',
    urls:['https://islamiccdn.com/audio/azan/azan3.mp3','https://www.islamcan.com/audio/adhan/azan3.mp3'] },
  { name:'Egypt Classic', place:'Cairo Style',        icon:'🌟',
    urls:['https://islamiccdn.com/audio/azan/azan4.mp3','https://www.islamcan.com/audio/adhan/azan4.mp3'] },
];

export const QURAN_CDN = 'https://cdn.islamic.network/quran/audio-surah/128/ar.alafasy/';
